<template>
  <b-card no-body>
    <h4 class="pl-1 pt-1">{{ title }}</h4>
    <b-table striped hover :items="items" small :fields="fields">
      <template #cell(progress)="data">
        <b-progress
          :value="data.item.progress ? (data.item.progress >= 100 ? 100 : data.item.progress) : 0"
          max="100"
          show-progress
          :animated="data.item.progress < 100"
          :variant="getBadgeColor(data.item.progress)"
          v-if="data.item.progress > 1"
        ></b-progress>
      </template>
    </b-table>
  </b-card>
</template>

<script>
export default {
  name: "OpList",
  data() {
    return {
      fields: [
        { key: "id", label: "#" },
        { key: "container.name", label: "Formato" },
        { key: "delivery_date", label: "Fecha entrega" },
        { key: "kilograms", label: "Kgs" },
        { key: "quantity", label: "Q" },
        { key: "completed_boxes", label: "Completado" },
        { key: "selected_boxes", label: "Seleccionado" },
        { key: "remaining_boxes", label: "Restante" },
        { key: "progress", label: "%" }
      ]
    };
  },
  props: {
    title: {
      type: String,
      default: "-"
    },
    items: {
      type: Array,
      default: () => []
    }
  },
  methods: {
    getBadgeColor(percentage) {
      // vigente, cancelado, completado
      if (percentage >= 100) {
        return "success";
      } else if (percentage < 100 && percentage > 0) {
        return "primary";
      } else {
        return "danger";
      }
    }
  }
};
</script>

<style></style>
